import { atom } from 'jotai';
import { LastWatchedExt } from '@shared/types';

const _lastWatchedAtom = atom<LastWatchedExt[]>([]);

export const lastWatchedAtom = atom(
  (get) => get(_lastWatchedAtom),
  (get, set, update: LastWatchedExt[]) => {
    const currentLength = get(_lastWatchedAtom).length;

    if (currentLength === 0 && update.length === 0) {
      return;
    }

    set(_lastWatchedAtom, update);
  }
);
